export default function AboutSection() {
  return (
    <section style={{ backgroundColor: "#141414" }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12 items-start">
          {/* Foto */}
          <div className="lg:col-span-1">
            <div className="relative w-full max-w-sm mx-auto lg:max-w-none aspect-[3/4] rounded-lg overflow-hidden border border-gold/20">
              <img
                src="https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/8c4063e5ebb9adfb53e0043a92eea591.webp"
                alt="Anna Sauch"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/20" />
            </div>
          </div>

          {/* Bio */}
          <div className="lg:col-span-2 flex flex-col justify-center">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream mb-2">
              Anna Sauch
            </h2>
            <p className="font-sans text-xs md:text-sm font-medium text-gold tracking-[0.2em] uppercase mb-6">
              Creadora de Mujer Abundante
            </p>
            <div className="space-y-4">
              <p className="font-sans text-sm md:text-base text-cream/80 leading-relaxed">
                Anna ayuda a mujeres a transformar su relación con el dinero desde lo práctico.
                Sin mística, sin promesas vacías. Solo un método que funciona.
              </p>
              <p className="font-sans text-sm md:text-base text-cream/80 leading-relaxed">
                Tras años trabajando con emprendedoras y profesionales, descubrió que la
                abundancia no es suerte: es un sistema reproducible. Y lo construyó en 5
                módulos que cualquiera puede aplicar, con videos cortos, guías descargables
                y plantillas listas para usar.
              </p>
              <p className="font-sans text-sm md:text-base text-cream/80 leading-relaxed">
                Hoy, cientos de mujeres han pasado de la incertidumbre financiera a cobrar
                con confianza, organizar su dinero y construir una vida con oportunidades
                reales. No con motivación vacía. Con habilidades, guiones y seguimiento.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Divider */}
      <div className="h-px bg-gold-gradient" />
    </section>
  );
}
